<template>
  <NfFormItem icon="name" :label="label">
    <div class="input-wrapper" slot="right">
      <input type="text" v-model="inputValue" placeholder="请填写" />
    </div>
  </NfFormItem>
</template>

<script>
import NfFormItem from "./NfFormItem"

export default {
  name: "uiFormItenName",
  props: {
    value: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: "姓名"
    }
  },
  components: {
    NfFormItem
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.input-wrapper {
  flex: 1;
  display: flex;
  align-items: center;
  input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    font-family: PingFangSC-Regular;
    font-size: 0.3rem;
    color: #333333;
    text-align: right;
    &::-webkit-input-placeholder {
      font-family: PingFangSC-Regular;
      font-size: 0.3rem;
      color: #cccccc;
    }
  }
}
</style>
